import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=0a488cef"
import script from "./CopyButton.vue?vue&type=script&lang=ts"
export * from "./CopyButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a488cef')) {
      api.createRecord('0a488cef', component.options)
    } else {
      api.reload('0a488cef', component.options)
    }
    module.hot.accept("./CopyButton.vue?vue&type=template&id=0a488cef", function () {
      api.rerender('0a488cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/CopyButton.vue"
export default component.exports